/* ICT header search (replaces Searchanise).
   - Focus with an empty box: recent searches, popular categories, and a random pick of popular + new products.
   - Typing: Shopify predictive search (title, brand, type, tags, SKU) rendered by sections/ict-predictive.
   - Keyboard: ↑ ↓ to move, Enter to open, Esc to close. The dropdown is exactly as wide as the search bar. */
(function () {
  var wrap = document.querySelector('[data-ict-search]');
  if (!wrap) return;
  var form = wrap.querySelector('[data-sd-form]');
  var input = wrap.querySelector('[data-sd-input]');
  var clearQ = wrap.querySelector('[data-sd-clearq]');
  var dropdown = wrap.querySelector('[data-ict-sd]');
  var empty = wrap.querySelector('[data-sd-empty]');
  var results = wrap.querySelector('[data-sd-results]');
  var recentBox = wrap.querySelector('[data-sd-recent]');
  var recentList = wrap.querySelector('[data-sd-recent-list]');
  var root = wrap.dataset.root || '/';
  var searchUrl = wrap.dataset.searchUrl || '/search';
  var RECENT_KEY = 'ict.search.recent';
  var picksLoaded = false;
  var controller = null;
  var timer = null;
  var active = -1;
  var cache = {};

  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function writeRecent(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {} }
  function remember(q) {
    var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    writeRecent(list);
  }

  function resultsUrl(q) {
    return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&options%5Bfields%5D=title,product_type,variants.title,vendor,variants.sku,tag';
  }

  function renderRecent() {
    var list = readRecent();
    recentBox.hidden = !list.length;
    recentList.replaceChildren();
    list.forEach(function (q) {
      var a = document.createElement('a');
      a.className = 'ict-sd-chip ict-sd-chip--recent';
      a.href = resultsUrl(q);
      a.dataset.sdItem = '';
      a.textContent = q;
      recentList.append(a);
    });
  }

  function shuffle(items) {
    for (var i = items.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = items[i]; items[i] = items[j]; items[j] = t; }
    return items;
  }

  function loadPicks() {
    if (picksLoaded) return;
    picksLoaded = true;
    [['[data-sd-popular]', 'best-selling'], ['[data-sd-new]', 'created-descending']].forEach(function (pair) {
      var target = wrap.querySelector(pair[0]);
      fetch(root + 'collections/all?sort_by=' + pair[1] + '&section_id=ict-search-picks')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = shuffle(Array.prototype.slice.call(doc.querySelectorAll('.ict-sd-prod'))).slice(0, 3);
          target.replaceChildren.apply(target, items);
          if (!items.length) target.closest('.ict-sd-block').hidden = true;
        })
        .catch(function () { target.closest('.ict-sd-block').hidden = true; });
    });
  }

  /* Keep the dropdown inside the visible area above the on-screen keyboard (iOS doesn't shrink vh). */
  function fit() {
    if (dropdown.hidden) return;
    var vv = window.visualViewport;
    var visible = vv ? vv.height + vv.offsetTop : window.innerHeight;
    var room = Math.round(visible - dropdown.getBoundingClientRect().top - 12);
    dropdown.style.maxHeight = Math.max(room, 200) + 'px';
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fit);
    window.visualViewport.addEventListener('scroll', fit);
  }

  function open() {
    if (!dropdown.hidden) return;
    dropdown.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    wrap.classList.add('is-open');
    if (!input.value.trim()) { renderRecent(); loadPicks(); }
    fit();
  }
  function close() {
    dropdown.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    wrap.classList.remove('is-open');
    setActive(-1);
  }

  function items() { return Array.prototype.slice.call(dropdown.querySelectorAll('[data-sd-item]')).filter(function (el) { return el.offsetParent !== null; }); }
  function setActive(i) {
    var list = items();
    list.forEach(function (el) { el.classList.remove('is-active'); });
    active = i;
    if (i >= 0 && list[i]) { list[i].classList.add('is-active'); list[i].scrollIntoView({ block: 'nearest' }); }
  }

  function highlight(container, q) {
    var words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 0; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return;
    var re = new RegExp('(' + words.join('|') + ')', 'ig');
    container.querySelectorAll('.ict-sd-prod__title').forEach(function (el) {
      var text = el.textContent;
      el.textContent = '';
      text.split(re).forEach(function (part) {
        if (!part) return;
        if (re.test(part)) { var m = document.createElement('mark'); m.textContent = part; el.append(m); }
        else el.append(document.createTextNode(part));
        re.lastIndex = 0;
      });
    });
  }

  function query(q) {
    if (controller) controller.abort();
    if (!q) { results.hidden = true; empty.hidden = false; renderRecent(); loadPicks(); return; }
    empty.hidden = true;
    results.hidden = false;
    if (cache[q]) { results.replaceChildren(cache[q].cloneNode(true)); setActive(-1); return; }
    results.classList.add('is-loading');
    controller = window.AbortController ? new AbortController() : null;
    var params = 'q=' + encodeURIComponent(q) + '&section_id=ict-predictive' +
      '&resources%5Btype%5D=product,collection,query' +
      '&resources%5Blimit%5D=8&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor,variants.sku,tag';
    fetch(root + 'search/suggest?' + params, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('.ict-sd-results');
        if (!node || input.value.trim() !== q) return;
        highlight(node, q);
        cache[q] = node;
        results.replaceChildren(node.cloneNode(true));
        results.classList.remove('is-loading');
        setActive(-1);
      })
      .catch(function () { results.classList.remove('is-loading'); });
  }

  function go(q) {
    q = (q || '').trim();
    if (!q) { input.focus(); return; }
    remember(q);
    window.location.href = resultsUrl(q);
  }

  input.addEventListener('focus', open);
  input.addEventListener('click', open);
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearQ.hidden = !input.value;
    open();
    clearTimeout(timer);
    timer = setTimeout(function () { query(q); }, 140);
  });
  input.addEventListener('keydown', function (e) {
    var list = items();
    if (e.key === 'ArrowDown') { e.preventDefault(); open(); setActive(Math.min(active + 1, list.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
    else if (e.key === 'Escape') { close(); }
    else if (e.key === 'Enter' && active >= 0 && list[active]) {
      e.preventDefault();
      var el = list[active];
      if (el.dataset.sdQuery) { remember(el.dataset.sdQuery); }
      window.location.href = el.href;
    }
  });
  clearQ.addEventListener('click', function () { input.value = ''; clearQ.hidden = true; input.focus(); query(''); });
  form.addEventListener('submit', function (e) { e.preventDefault(); go(input.value); });
  dropdown.addEventListener('click', function (e) {
    var clear = e.target.closest('[data-sd-clear]');
    if (clear) { e.preventDefault(); writeRecent([]); renderRecent(); input.focus(); return; }
    var link = e.target.closest('a[data-sd-query], a[data-sd-all], .ict-sd-chip--recent');
    if (link) { remember(link.dataset.sdQuery || (link.classList.contains('ict-sd-chip--recent') ? link.textContent : input.value.trim())); }
  });
  // Safari doesn't focus links on click, so focus leaves the bar mid-click; don't close while a press inside is in progress.
  var pressing = false;
  wrap.addEventListener('pointerdown', function () { pressing = true; });
  document.addEventListener('pointerup', function () { setTimeout(function () { pressing = false; }, 300); });
  document.addEventListener('pointerdown', function (e) { if (!wrap.contains(e.target)) close(); });
  wrap.addEventListener('focusout', function (e) {
    if (pressing || (e.relatedTarget && wrap.contains(e.relatedTarget))) return;
    setTimeout(function () { if (!pressing && !wrap.contains(document.activeElement)) close(); }, 0);
  });
  clearQ.hidden = !input.value;

  // Animated placeholder: types a greeting and hints in English and Burmese, one after another.
  // Types whole grapheme clusters so Burmese characters never appear half-formed; pauses while the
  // field is focused; just rotates without typing when the visitor prefers reduced motion.
  (function () {
    var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var phrases = small ? [
      'Mingalarpar! Search products',
      'မင်္ဂလာပါ — ပစ္စည်းရှာဖွေပါ',
      'Search brands or models',
      'အမှတ်တံဆိပ်၊ မော်ဒယ် ရှာပါ'
    ] : [
      'Mingalarpar! Search products, brands or model numbers',
      'မင်္ဂလာပါ — ပစ္စည်း၊ အမှတ်တံဆိပ် သို့မဟုတ် မော်ဒယ်နံပါတ်ဖြင့် ရှာဖွေပါ',
      'Search laptops, phones, CCTV and more',
      'လက်ပ်တော့ပ်၊ ဖုန်း၊ CCTV နှင့် အခြားပစ္စည်းများကို ရှာဖွေပါ'
    ];
    var still = input.getAttribute('placeholder');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seg = window.Intl && Intl.Segmenter ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
    function chars(t) { return seg ? Array.from(seg.segment(t), function (x) { return x.segment; }) : Array.from(t); }
    var i = 0, pos = 0, deleting = false, list = chars(phrases[0]), timer;
    function tick() {
      if (document.activeElement === input || input.value) { input.setAttribute('placeholder', still); timer = setTimeout(tick, 600); return; }
      if (reduce) {
        input.setAttribute('placeholder', phrases[i]);
        i = (i + 1) % phrases.length;
        timer = setTimeout(tick, 3200);
        return;
      }
      if (!deleting) {
        pos++;
        input.setAttribute('placeholder', list.slice(0, pos).join(''));
        if (pos >= list.length) { deleting = true; timer = setTimeout(tick, 2200); return; }
        timer = setTimeout(tick, 45);
      } else {
        pos -= 2;
        if (pos <= 0) {
          pos = 0; deleting = false;
          i = (i + 1) % phrases.length; list = chars(phrases[i]);
          input.setAttribute('placeholder', '');
          timer = setTimeout(tick, 350);
          return;
        }
        input.setAttribute('placeholder', list.slice(0, pos).join(''));
        timer = setTimeout(tick, 22);
      }
    }
    timer = setTimeout(tick, 800);
  })();
})();
